// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"526":"fa52555c","739":"283ff1bd"}[chunkId] + ".chunk.js";
};